import Price from "components/Price/Price"
import _ from "lodash"
import React from "react"
import { Component } from "react"
import { Link, NavLink } from "react-router-dom"
import { Button } from "semantic-ui-react"
import shop from "shop/shop"
import ordinals from "theme/arnoldsports/sortParamsVariant"

export default class Variants extends Component {

  state = {
    selectedArt: false,
  }

  selectType = ( selectedArt ) => {
    this.setState( { selectedArt } )
  }

 componentWillReceiveProps( props ) {
    const { selectByField = "Variante" } = props
    if ( props.product !== this.props.product || props.byAttribute && !this.state.selectedArt ) {
      if ( props.product ) {
        this.selectType( props.product.extraValue[ selectByField ] )
      }
      else {
        this.selectType( _.keys( props.byAttribute[ selectByField ] )[ 0 ] )
      }
    }
  }

  render() {
    const { byAttribute, product } = this.props
    const {selectedArt} = this.state
    console.log("itemprodcut: ", product)
    if(product.extraValue.BREITE_CM == ''){
      product.extraValue.BREITE_CM = product.map_id.substring(product.map_id.length-6,product.map_id.length-3)
    }
    if(product.extraValue.LAENGE_CM == ''){
      product.extraValue.LAENGE_CM = product.map_id.substring(product.map_id.length-3,product.map_id.length)
    }
    if ( !byAttribute ) return null
    const pinnedAttr = {}
    console.log('Attributes: ',shop.config.variantNames);
    let i = 0;
    const sortedByLength = [];
    for (const key in byAttribute.LAENGE_CM) {
      const items = byAttribute.LAENGE_CM[key];
      for (const item of items) {
        for(let j = 0; j < product.parts.articles.length; j++){
          console.log("product.parts.articles ",product.parts.articles[i], " item.map_id ", items[j].map_id)
          const article = product.parts.articles.find(a => a === item.map_id);
          if(product.parts.articles[i] == items[j].map_id){
            sortedByLength.push(items[j]);
            console.log("ITEM PUSHED")
          }
        }
        i++
      }
    }
    /*sortedByLength.sort((a, b) => {
      const lengthA = a.extraValue.LAENGE_CM;
      const lengthB = b.extraValue.LAENGE_CM;
      return lengthA - lengthB;
    });*/
    const sortedByLengthObj = {};
    sortedByLength.forEach(item => {
      sortedByLengthObj[item.map_id] = item;
    });
    console.log("sortedByLength: ", {sortedByLength} )
    console.log("byAttribute.LAENGE_CM: ", byAttribute.LAENGE_CM )

    if ( shop.config.variantNames ) {
      shop.config.variantNames.forEach( variantKey => {
        pinnedAttr[ variantKey ] = product.extraValue[ variantKey ]
      } )
      return (
        <div>
          {shop.config.variantNames.map( variantKey => {
            const variants = byAttribute[ variantKey ]
            const pinned = { ...pinnedAttr }
            delete pinned[ variantKey ]

            const variantKeys = _.keys( variants )
             // TODO: UNIFY
            const keys = variantKeys.sort( ( a, b ) => {
              let s0 = ordinals[ a ]
              let s1 = ordinals[ b ]
                if(!s0 && !s1){
                    return Number(a) >= Number(b) ? 1: -1
                }
              return s0 >= s1 ? 1 : -1
            } )
           if ( !keys || keys.length <= 1 ) return null


            const selected = product.extraValue[ variantKey ]
            return <div className="variant-group pb3" key={variantKey}>
              <h4>{translate( variantKey )}</h4>
              {
                _.map( keys, ( key ) => {
                  let items = variants[ key ]
                  let item = _.first( items.filter( p => {
                    let hit = false
                    _.forEach( pinned, ( value, key ) => {
                      hit = hit || p.extraValue[ key ] === value
                    } )
                    return hit
                  } ) )
                  if ( !item ) {
                    item = items[ 0 ]
                  }
                  return <Button size="tiny"
                                 as={Link}
                                 className={`button-variant ${selected === item.extraValue[ variantKey ] ? "selected" : null} `}
                                 to={{ pathname: `/product/${item.map_id}/`, state: { preventScrollToTop: true } }} key={key}
                                 onClick={() => this.selectType( key )}
                                 basic>{translate( key )}</Button>
                } )
              }
            </div>
          } )}
        </div>
      )
    }
    return (
      <div>
        {/*byAttribute.Variante &&
        <div>
          <h4>Artikelart</h4>
          {_.map( _.keys( byAttribute.Variante ), ( key ) => {
            let items = byAttribute.Variante[ key ] ||[]
            let item = items[ 0 ]
            items.forEach(i => {
              if(i.extraValue.groesse === product.extraValue.groesse) item = i
            })
            console.log( selectedArt, item.extraValue.Variante )
            return <Button size="tiny" as={NavLink}
                           activeClassName="selected"
                           className={`button-variant ${selectedArt === item.extraValue.Variante ? "selected" : null} `}
                           to={{ pathname: `/product/${item.map_id}`, state: { preventScrollToTop: true } }} key={key}
                           onClick={() => this.selectType( key )}
                           basic>{translate( key )}</Button>
          } )}
        </div>*/}

        <h4 className="pt3">Größe</h4>
        {/*console.log("itemsprodcut ????",byAttribute.LAENGE_CM)*/}
        {_.map( {sortedByLength}, ( items ) => {
          return items
            .filter( p => p.extraValue.Variante === selectedArt )
            .map( item => { console.log("selectedArt",item)
              return <Button key={item.map_id} className="tl button-variant f6 dim br5 ph3 pv2 mb2 dib" size="tiny" basic as={NavLink}
                             activeClassName="selected"
                             to={{
                               pathname: `/product/${item.map_id}`,
                               state:    { preventScrollToTop: true }
                             }}>{item.extraValue.BREITE_CM} x {item.extraValue.LAENGE_CM}
                <br/><Price className="">{item.price}</Price></Button>
            } )
        } )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/mags/components/Variants/Variants.js